<template>
  <div>
    <h3>连接/断开</h3>
    <el-divider></el-divider>
    <el-form :model="connectModel" inline>
      <el-form-item label="连接地址">
        <el-input
          v-model.trim="connectModel.connectUrl"
          placeholder="连接地址"
        ></el-input>
      </el-form-item>
      <el-form-item label="客户端ID">
        <el-input
          v-model.trim="connectModel.clientId"
          placeholder="客户端ID"
        ></el-input>
      </el-form-item>
      <el-form-item label="用户名">
        <el-input
          v-model.trim="connectModel.username"
          placeholder="用户名"
        ></el-input>
      </el-form-item>
      <el-form-item label="密码">
        <el-input
          v-model.trim="connectModel.password"
          placeholder="密码"
        ></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="connect" v-show="!hasConnect"
          >连接</el-button
        >
        <el-button type="danger" @click="destroyConnection" v-show="hasConnect"
          >断开</el-button
        >
      </el-form-item>
    </el-form>
    <h3>订阅</h3>
    <el-divider></el-divider>
    <el-form :model="subscribeModel" inline>
      <el-form-item label="主题">
        <el-input
          v-model.trim="subscribeModel.topic"
          placeholder="主题"
        ></el-input>
      </el-form-item>
      <el-form-item label="QoS">
        <el-select v-model="subscribeModel.qos">
          <el-option label="0" :value="0"></el-option>
          <el-option label="1" :value="1"></el-option>
          <el-option label="2" :value="2"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="success" @click="addSubscribe" v-show="hasConnect"
          >添加订阅</el-button
        >
      </el-form-item>
    </el-form>

    <el-table :data="subscribeList">
      <el-table-column label="序号" type="index"></el-table-column>
      <el-table-column
        label="主题"
        prop="topic"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column
        label="QoS"
        prop="qos"
        show-overflow-tooltip
      ></el-table-column>
      <el-table-column label="操作">
        <template v-slot="{ row }">
          <el-tag effect="dark" type="danger" @click="unsubscribe(row)"
            >取消订阅</el-tag
          >
        </template>
      </el-table-column>
    </el-table>

    <h3 style="margin-top: 10px">消息发送</h3>
    <el-divider></el-divider>
    <el-form :model="publishModel" inline>
      <el-form-item label="主题">
        <el-input
          v-model.trim="publishModel.topic"
          placeholder="主题"
        ></el-input>
      </el-form-item>
      <el-form-item label="QoS">
        <el-select v-model="publishModel.qos">
          <el-option label="0" :value="0"></el-option>
          <el-option label="1" :value="1"></el-option>
          <el-option label="2" :value="2"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="内容">
        <el-input
          v-model.trim="publishModel.payload"
          placeholder="内容"
        ></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="success" @click="publishMsg" v-show="hasConnect"
          >发送</el-button
        >
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import mqtt from "mqtt";
export default {
  data() {
    return {
      connectModel: {
        connectUrl: "ws://10.14.2.113:13083/mqtt",
        clientId: "client_" + Math.random().toString(16).substring(2, 8),
        username: "emqx_u_1",
        password: "emqx_p",
      },
      client: null,
      subscribeModel: {
        topic: "",
        qos: 0,
      },
      subscribeList: [],
      publishModel: {
        topic: "",
        qos: 0,
        payload: "",
      },
    };
  },
  computed: {
    hasConnect() {
      return !(this.client == null);
    },
  },
  mounted() {},
  methods: {
    connect() {
      const { connectUrl, ...options } = this.connectModel;
      if (!connectUrl) {
        this.$message.error("连接地址不能为空！");
        return;
      }
      let client = mqtt.connect(connectUrl, options);
      client.on("connect", () => {
        this.client = client;
      });
      client.on("close", () => {
        this.destroyConnection();
      });
      client.on("message", (topic, message) => {
        this.$notify({
          title: topic,
          message: message,
        });
      });
      client.on("error", (error) => {
        this.$message.error("连接发生错误");
      });
    },
    destroyConnection() {
      if (this.client) {
        this.client.end(false, () => {
          this.client = null;
          this.subscribeList = [];
        });
      }
    },
    addSubscribe() {
      const { topic, qos } = this.subscribeModel;
      if (!topic) {
        this.$message.error("主题不能为空！");
        return;
      }
      if (this.subscribeList.findIndex((r) => r.topic == topic) >= 0) {
        this.$message.error("已订阅该主题");
        return;
      }
      this.client.subscribe(topic, { qos }, (error, res) => {
        if (error) {
          this.$message.error("订阅失败");
          return;
        }
        this.subscribeList.push({
          topic,
          qos,
        });
        this.$set(this.subscribeModel, "topic", "");
        this.$set(this.subscribeModel, "qos", 0);
      });
    },
    unsubscribe(row) {
      const { topic } = row;
      this.client.unsubscribe(topic, (error) => {
        if (error) {
          this.$message.error("取消订阅失败");
          return;
        }
        let index = this.subscribeList.findIndex((r) => r.topic == topic);
        this.subscribeList.splice(index, 1);
      });
    },
    publishMsg() {
      const { topic, qos, payload } = this.publishModel;
      if (!topic) {
        this.$message.error("主题不能为空！");
        return;
      }
      if (!payload) {
        this.$message.error("内容不能为空！");
        return;
      }
      this.client.publish(topic, payload, { qos }, (error) => {
        if (error) {
          this.$message.error("发送失败");
          return;
        }
        this.$message.success("发送成功");
      });
    },
  },
  beforeDestroy() {
    this.destroyConnection();
  },
};
</script>

<style>
</style>